export default __webpack_public_path__ + "header-mobile.webp";